module.exports = __webpack_public_path__ + "assets/img/slogan-f07ce26e.png";